export const HBMenuItems = [
  {
    title: "Home",
    url: "/",
    className: "nav-links",
  },
  {
    title: "FAQ",
    url: "/FAQ",
    className: "nav-links",
  },
  {
    title: "Follow Us",
    url: "/FollowUs",
    className: "nav-links",
  },
  {
    title: "Find us",
    url: "/FindUs",
    className: "nav-links",
  },
];
